export const PAGE_TYPES = {
  BROWSE: 'browse',
  SEARCH: 'search',
  CANNED: 'canned',
  DIRECTORY: 'directory'
}

export const getPageType = path => {
  switch (true) {
    case path?.includes('/browse'):
      return PAGE_TYPES.BROWSE
    case path?.includes('/list'):
      return PAGE_TYPES.CANNED
    case path?.includes('/sd'):
      return PAGE_TYPES.DIRECTORY
    default:
      return PAGE_TYPES.SEARCH
  }
}
